<template>
  <doctor-form
    :visible="editDoctorDialog"
    :dialogTitle="'hfManagement.editDoctorDialogTitle'"
    :doctor="doctor"
    :serviceList="serviceList"
    :initFormValid="true"
    :hasDeleteAction="true"
    :hasWritePerm="hasWritePerm"
    @close="closeEditDoctorDialog"
    @setdoctorname="setDoctorName"
    @setdoctorsurname="setDoctorSurname"
    @setservicelist="setServiceList"
    @savedoctor="updateDoctor"
    @deletedoctor="deleteDoctor"
  />
</template>

<script>
import findIndex from "lodash/findIndex";
import isEmpty from "lodash/isEmpty";
import HFDoctorForm from "./HFDoctorForm";

export default {
  components: {
    DoctorForm: HFDoctorForm
  },
  props: {
    editDoctorDialog: {
      type: Boolean,
      required: true
    },
    officeId: {
      type: String,
      required: true
    },
    selectedDoctorService: {
      type: Object,
      required: true
    },
    hasWritePerm: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    selectedDoctorService: {
      handler: function () {
        if (!isEmpty(this.selectedDoctorService)) {
          this.doctorId = this.selectedDoctorService.doctorId;
          this.doctor = { ...this.selectedDoctorService.doctor };
          this.serviceList = [...this.selectedDoctorService.serviceList];
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      doctorId: null,
      doctor: {},
      serviceList: []
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    isDoctorInfoUpdated() {
      return (
        this.doctor.name !== this.selectedDoctorService.doctor.name ||
        this.doctor.surname !== this.selectedDoctorService.doctor.surname
      );
    }
  },
  methods: {
    initialize() {},
    closeEditDoctorDialog() {
      this.$emit("closeeditdoctordialog");
    },
    setDoctorName(name) {
      this.doctor.name = name;
    },
    setDoctorSurname(surname) {
      this.doctor.surname = surname;
    },
    setServiceList(serviceList) {
      this.serviceList = serviceList;
    },
    updateDoctor() {
      if (this.isDoctorInfoUpdated) {
        return this.$store
          .dispatch("doctors/updateDoctor", {
            officeId: this.officeId,
            doctorId: this.doctorId,
            doctor: this.doctor
          })
          .then(() => {
            return this.allDeleteServicePromises();
          })
          .then(() => {
            return this.allAddServicePromises();
          })
          .then(() => {
            this.$emit("closeeditdoctordialog");
          })
          .then(() => {
            return this.$store.dispatch(
              "doctors/fetchDoctorServiceList",
              this.officeId
            );
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        return this.allDeleteServicePromises()
          .then(() => {
            return this.allAddServicePromises();
          })
          .then(() => {
            this.$emit("closeeditdoctordialog");
          })
          .then(() => {
            return this.$store.dispatch(
              "doctors/fetchDoctorServiceList",
              this.officeId
            );
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    deleteDoctor() {
      return this.$store
        .dispatch("doctors/deleteDoctor", this.doctorId)
        .then(() => {
          this.$emit("closeeditdoctordialog");
        })
        .then(() => {
          return this.$store.dispatch(
            "doctors/fetchDoctorServiceList",
            this.officeId
          );
        })
        .catch(() => {})
        .finally(() => {});
    },
    allAddServicePromises() {
      return Promise.all(this.serviceList.map(this.singleAddServicePromise()));
    },
    allDeleteServicePromises() {
      return Promise.all(
        this.selectedDoctorService.serviceList.map(
          this.singleDeleteServicePromise()
        )
      );
    },
    singleAddServicePromise() {
      return service => {
        if (
          findIndex(this.selectedDoctorService.serviceList, {
            serviceId: service.serviceId
          }) === -1
        ) {
          return new Promise((resolve, reject) => {
            return this.$store
              .dispatch("doctors/updateDoctorService", {
                doctorService: {
                  doctorId: this.doctorId,
                  serviceId: service.serviceId
                },
                service
              })
              .then(() => {
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };
    },
    singleDeleteServicePromise() {
      return service => {
        if (
          findIndex(this.serviceList, {
            serviceId: service.serviceId
          }) === -1
        ) {
          return new Promise((resolve, reject) => {
            return this.$store
              .dispatch("doctors/deleteDoctorService", {
                doctorService: {
                  doctorId: this.doctorId,
                  serviceId: service.serviceId
                }
              })
              .then(() => {
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };
    }
  }
};
</script>
